{
  "_provenance": {
    "ns": "circle",
    "source": "pages/CirclePage.tsx and components/circle/** (#2109 R3 lane L6)"
  },
  "caseManager": {
    "none": "No case manager is assigned to your family yet. Their name will appear here once TRF assigns one.",
    "notEmergency": "TRF isn’t an emergency service.",
    "replyPromise_one": "Replies within {{count}} business day.",
    "replyPromise_other": "Replies within {{count}} business days.",
    "title": "Your TRF contact"
  },
  "header": {
    "title": "Resources"
  },
  "resources": {
    "category": {
      "community": "Community",
      "counseling": "Counseling",
      "financial": "Financial",
      "housing": "Housing",
      "legal": "Legal",
      "medical": "Medical",
      "other": "Other"
    },
    "checked": "Checked {{date}}",
    "intro": "Support and services the Tyler Robinson Foundation wants you to know about.",
    "report": {
      "body": "Tell us what went wrong, if you like. TRF will look at this entry.",
      "failed": "Couldn’t send that. Please try again.",
      "link": "This didn’t work",
      "noteLabel": "What happened (optional)",
      "send": "Send",
      "sent": "Thanks. TRF will look at this entry.",
      "title": "Tell TRF this didn’t work",
      "tooSoon": "You already told us about this one this week."
    },
    "title": "Services and support",
    "trfGroup": "TRF group",
    "visit": "Visit"
  }
}
